import React from "react";
import {
  Box,
  Button,
  Chip,
  MenuItem,
  Select,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

import MainWithoutResult from "../../General/MainWithoutResult";
import { colors } from "../../../../assets/colors";
import { simpleAlerts } from "../../../../utils/alerts";
import { CODES } from "../../../../utils/responseCodes";
import ConfiguracionService from "../../../../services/configuracion";

const BodyConsejero = ({
  cecos,
  setCecos,
  tiposSeguro,
  modalidades,
  setOpenModalLoader,
}) => {

  const handleTipo = (index, value) => {

    const data = [...cecos];

    data[index] = {
      ...data[index],
      tipo: value,
      estado: "PENDIENTE",
    };

    setCecos(data);
  };

  const handleModalidad = (index, value) => {

    const data = [...cecos];

    data[index] = {
      ...data[index],
      modalidad: value,
      estado: "PENDIENTE",
    };

    setCecos(data);
  };


  const guardarTodo = async () => {
    const incompletos = cecos.filter(
      (x) =>
        (x.tipo && !x.modalidad) ||
        (!x.tipo && x.modalidad)
    );


    if (incompletos.length > 0) {

      const mensaje = (
        <div>
          <strong>CECO incompletos:</strong>

          <ul
            style={{
              margin: "8px 0 0 20px",
              padding: 0,
            }}
          >

            {incompletos.map((x) => (
              <li key={x.id}>
                {x.ceco}
              </li>
            ))}

          </ul>
        </div>
      );

      simpleAlerts(
        mensaje,
        "warning"
      );

      return;
    }

    const guardar = cecos.filter(
      (x) => x.tipo && x.modalidad
    );

    if (guardar.length === 0) {
      simpleAlerts(
        "No existen configuraciones para guardar.",
        "warning"
      );

      return;
    }
    try {
      const payload = {

        configuraciones: guardar.map((x) => ({
          idceco: x.id,
          idtipoSeguro: x.tipo,
          idmodalidad: x.modalidad,
        })),

      };
      setOpenModalLoader(true);
      const result =
        await ConfiguracionService.guardarConfiguracionesCeco(
          payload
        );

      if (
        result.status === CODES.SUCCESS_200
      ) {

        const data = cecos.map((item) => {
          if (
            item.tipo &&
            item.modalidad
          ) {

            return {
              ...item,
              estado: "GUARDADO",
            };

          }

          return item;

        });
        setCecos(data);

        simpleAlerts(
          "Configuraciones guardadas correctamente.",
          "success"
        );

      } else {

        simpleAlerts(
          result.response?.data?.message ||
          "Hubo un error al guardar las configuraciones.",
          "error"
        );

      }

    } catch (error) {

      console.log(
        "guardarConfiguracionesCeco",
        error
      );

      simpleAlerts(
        "Hubo un error al guardar las configuraciones.",
        "error"
      );

    } finally {
      setOpenModalLoader(false);

    }

  };
  const obtenerEstado = (row) => {
    if (
      !row.tipo &&
      !row.modalidad
    ) {

      return "SIN_CONFIGURAR";

    }

    if (
      (row.tipo && !row.modalidad) ||
      (!row.tipo && row.modalidad)
    ) {

      return "PENDIENTE";

    }

    return row.estado ?? "PENDIENTE";
  };

  return (

    <Box className="page-body-main">
      <Box
        display="flex"
        justifyContent="flex-end"
        mb={2}
      >

        <Button
          variant="contained"
          color="success"
          startIcon={<SaveIcon />}
          onClick={guardarTodo}
          disabled={cecos.length === 0}
        >
          Guardar
        </Button>

      </Box>
      <Box className="page-body-table table-responsive-md">

        <table className="table table-hover table-striped table-bordered">

          <thead
            className="sticky-top"
            style={{
              backgroundColor: colors.quaternary.hex,
              color: "#fff",
              whiteSpace: "nowrap",
            }}
          >

            <tr>

              <th>
                CECO
              </th>

              <th
                style={{
                  width: 180,
                }}
              >
                Tipo
              </th>

              <th
                style={{
                  width: 200,
                }}
              >
                Modalidad
              </th>

              <th
                style={{
                  width: 130,
                }}
              >
                Estado
              </th>

            </tr>

          </thead>


          <tbody>

            {cecos.map((row, index) => (

              <tr
                key={row.id}
              >
                <td>
                  {row.ceco}
                </td>
                <td>

                  <Select
                    fullWidth
                    size="small"
                    value={row.tipo ?? ""}
                    displayEmpty
                    onChange={(e) =>
                      handleTipo(
                        index,
                        e.target.value
                      )
                    }
                  >

                    <MenuItem value="">
                      <em>
                        Seleccionar
                      </em>
                    </MenuItem>


                    {tiposSeguro?.map((item) => (

                      <MenuItem
                        key={item.id}
                        value={item.id}
                      >
                        {item.nombre}
                      </MenuItem>

                    ))}

                  </Select>

                </td>
                <td>

                  <Select
                    fullWidth
                    size="small"
                    value={row.modalidad ?? ""}
                    displayEmpty
                    onChange={(e) =>
                      handleModalidad(
                        index,
                        e.target.value
                      )
                    }
                  >

                    <MenuItem value="">
                      <em>
                        Seleccionar
                      </em>
                    </MenuItem>


                    {modalidades?.map((item) => (

                      <MenuItem
                        key={item.id}
                        value={item.id}
                      >
                        {item.nombre}
                      </MenuItem>

                    ))}

                  </Select>

                </td>
                <td align="center">

                  {obtenerEstado(row) ===
                    "SIN_CONFIGURAR" && (

                    <Chip
                      label="Sin configurar"
                      size="small"
                      color="default"
                    />

                  )}


                  {obtenerEstado(row) ===
                    "PENDIENTE" && (

                    <Chip
                      label="Pendiente"
                      size="small"
                      color="warning"
                    />

                  )}


                  {obtenerEstado(row) ===
                    "GUARDADO" && (

                    <Chip
                      label="Guardado"
                      size="small"
                      color="success"
                    />

                  )}

                </td>

              </tr>

            ))}
            {cecos.length === 0 && (
              <MainWithoutResult />
            )}

          </tbody>

        </table>

      </Box>

    </Box>

  );
};

export default BodyConsejero;